module.exports = __webpack_public_path__ + "img/Nordeste.1d21fe80.png";